import { Mail, Home } from "react-feather";

const Menu = [
  {
    id: "home",
    title: "Home",
    icon: <Home size={20} />,
    navLink: "/home",
  },
  {
    id: "secondPage",
    title: "Second Page - medina",
    icon: <Mail size={20} />,
    navLink: "/second-page",
  },
];
export default Menu;